import { useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import LocationNotes from '../../locations/navPages/LocationNotes'

/**
 * Notes for one project, in the two-column workspace layout.
 *
 * Project notes are LocationNotes scoped by `projectid` (there is no project
 * note model), so this screen is a thin delegation to the location one.
 */
const ProjectNotes = () => {
	const { id } = useParams<{ id: string }>()

	const { project, loading } = useSelector((state: any) => ({
		loading: state.projects.isLoading,
		project: state.projects.entities[id as string],
	}))

	const locationId = project ? project.projectAsset?._id : null

	if (loading || !project || !locationId) return null

	return (
		<LocationNotes
			locationid={locationId}
			projectid={id}
			surfaceKey="project"
			subtitle={project.projectName || 'this project'}
		/>
	)
}

export default ProjectNotes
